import React from "react";
import "./ContentLoader.scss";

const ContentLoader = ({
  text = "Loading your content...",
  variant = "page",
  size,
  className = "",
}) => {
  const showPanel = variant === "page";
  const spinnerStyle = size
    ? { width: size, height: size }
    : undefined;

  return (
    <div
      className={`content-loader content-loader--${variant}${
        className ? ` ${className}` : ""
      }`}
      role="status"
      aria-live="polite"
      aria-label={text || "Loading"}
    >
      <div
        className={`content-loader__inner${
          showPanel ? " content-loader__inner--panel" : ""
        }`}
      >
        <span
          className="content-loader__spinner"
          style={spinnerStyle}
          aria-hidden="true"
        />
        {text && <p className="content-loader__text">{text}</p>}
      </div>
    </div>
  );
};

export default ContentLoader;
